module.exports = __webpack_public_path__ + "static/img/scwm.7c95926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/scwm.png
// module id = ghOD
// module chunks = 1